import { render } from "./ViewContainer.vue?vue&type=template&id=e07677b2"
import script from "./ViewContainer.vue?vue&type=script&lang=js"
export * from "./ViewContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__